const DOPA_I18N = (() => {
  try {
    const node = document.getElementById('DopaI18n');
    return node ? JSON.parse(node.textContent || '{}') : {};
  } catch (_) {
    return {};
  }
})();
const dopaT = (key, fallback, variables = {}) => {
  let value = String(DOPA_I18N[key] || fallback || '');
  Object.entries(variables).forEach(([name, replacement]) => {
    value = value.split(`__${name.toUpperCase()}__`).join(String(replacement));
  });
  return value;
};
const dopaBagLabel = (count) => {
  const n = Math.max(0, Number(count) || 0);
  const template = n === 1 ? dopaT('itemOne', 'Bag with __COUNT__ item') : dopaT('itemOther', 'Bag with __COUNT__ items');
  return template.replaceAll('__COUNT__', String(n));
};

(() => {
  const body = document.body;
  const open = document.querySelector('[data-menu-open]');
  const close = document.querySelector('[data-menu-close]');
  const menu = document.querySelector('[data-mobile-menu]');
  let lastFocused = null;

  const focusables = (root) => [...root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')];
  const hideMenu = () => {
    if (!menu) return;
    menu.hidden = true;
    body.classList.remove('menu-open');
    open?.setAttribute('aria-expanded', 'false');
    lastFocused?.focus();
  };
  const showMenu = () => {
    if (!menu) return;
    lastFocused = document.activeElement;
    menu.hidden = false;
    body.classList.add('menu-open');
    open?.setAttribute('aria-expanded', 'true');
    focusables(menu)[0]?.focus();
  };

  open?.addEventListener('click', showMenu);
  close?.addEventListener('click', hideMenu);
  menu?.querySelectorAll('a').forEach((a) => a.addEventListener('click', hideMenu));
  menu?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') return hideMenu();
    if (event.key !== 'Tab') return;
    const items = focusables(menu);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  function bindProductVariantUI(root = document) {
    root.querySelectorAll('.js-product-form:not([data-variant-ui-bound])').forEach((form) => {
      form.setAttribute('data-variant-ui-bound','true');
      const select = form.querySelector('[data-variant-select]');
      const radios = [...form.querySelectorAll('[data-variant-radio]')];
      const section = form.closest('[data-product-section]');
      if ((!select && !radios.length) || !section) return;
      const current = section.querySelector('.product-price-current');
      const compare = section.querySelector('.product-price-compare');
      const unitPrice = section.querySelector('[data-unit-price]');
      const submit = form.querySelector('[data-product-submit]');
      const dynamicCheckout = form.querySelector('[data-dynamic-checkout]');
      const selectedControl = () => radios.length ? radios.find((radio) => radio.checked) : select?.options[select.selectedIndex];
      const update = () => {
        const option = selectedControl();
        if (!option) return;
        if (current) current.textContent = option.dataset.price || current.textContent;
        if (compare) {
          if (option.dataset.compare) { compare.textContent = option.dataset.compare; compare.hidden = false; }
          else { compare.textContent = ''; compare.hidden = true; }
        }
        if (unitPrice) {
          if (option.dataset.unitPrice) { unitPrice.textContent = option.dataset.unitPrice; unitPrice.hidden = false; }
          else { unitPrice.textContent = ''; unitPrice.hidden = true; }
        }
        const isPreorder = !!form.querySelector('[name="properties[Pre-order delivery]"]');
        const optionAvailable = option.dataset.available === 'true';
        const optionPurchasable = optionAvailable;
        if (submit) {
          submit.disabled = !optionPurchasable;
          submit.textContent = optionPurchasable ? dopaT('addToCart','Add to cart') : (isPreorder ? dopaT('preorderUnavailable','Pre-order unavailable') : dopaT('soldOut','Sold out'));
        }
        if (dynamicCheckout) dynamicCheckout.hidden = !optionPurchasable;
        const mobileBuy = document.querySelector('[data-mobile-buy]');
        const mobilePrice = mobileBuy?.querySelector('[data-mobile-buy-price]');
        const mobileButton = mobileBuy?.querySelector('[data-mobile-add]');
        if (mobilePrice && option.dataset.price) mobilePrice.textContent = option.dataset.price;
        if (mobileButton) {
          mobileButton.textContent = optionPurchasable ? dopaT('addToCart','Add to cart') : (isPreorder ? dopaT('preorderUnavailable','Pre-order unavailable') : dopaT('viewOptions','View options'));
          if (optionPurchasable) mobileButton.removeAttribute('data-scroll-only'); else mobileButton.setAttribute('data-scroll-only','true');
        }
        radios.forEach((radio) => radio.closest('.pack-option')?.classList.toggle('is-selected', radio.checked));
      };
      select?.addEventListener('change', update);
      radios.forEach((radio) => radio.addEventListener('change', update));
      update();
    });
  }
  bindProductVariantUI(document);

  document.querySelectorAll('.js-localization-form').forEach((form) => {
    form.querySelectorAll('[data-localization-select]').forEach((select) => select.addEventListener('change', () => {
      try {
        const configNode = document.getElementById('DopaLocalizationConfig');
        const config = configNode ? JSON.parse(configNode.textContent || '{}') : {};
        const days = Math.max(7, Number(config.preferenceDays) || 91);
        localStorage.setItem('dopa_localization_manual_until', String(Date.now() + days * 86400000));
      } catch (_) {}
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }));
  });

  document.querySelectorAll('[data-product-recommendations]').forEach((container) => {
    if (container.innerHTML.trim()) return;
    const url = container.dataset.url;
    if (!url) return;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const replacement = html.querySelector('[data-product-recommendations]');
        if (replacement?.innerHTML.trim()) { container.innerHTML = replacement.innerHTML; bindQuickAdd(container); }
      })
      .catch(() => {});
  });




  const megaMenu = document.querySelector('[data-mega-menu]');
  const megaTrigger = megaMenu?.querySelector('[data-mega-trigger]');
  const closeMega = () => { if (!megaMenu) return; megaMenu.classList.remove('is-open'); megaTrigger?.setAttribute('aria-expanded','false'); };
  const openMega = () => { if (!megaMenu) return; megaMenu.classList.add('is-open'); megaTrigger?.setAttribute('aria-expanded','true'); };
  megaTrigger?.addEventListener('click', (event) => { event.stopPropagation(); megaMenu.classList.contains('is-open') ? closeMega() : openMega(); });
  document.addEventListener('click', (event) => { if (megaMenu && !megaMenu.contains(event.target)) closeMega(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMega(); });

  const normalizeCartQuantity = (value) => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return 1;
    return Math.max(1, Math.floor(parsed));
  };

  const setCommerceStatus = (status, message = '', isError = false) => {
    if (!status) return;
    status.textContent = message;
    if (isError) {
      status.setAttribute('role', 'alert');
      status.setAttribute('aria-live', 'assertive');
    } else {
      status.removeAttribute('role');
      status.setAttribute('aria-live', 'polite');
    }
  };

  async function readCart() {
    const rootPath = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${rootPath}cart.js`, {
      headers:{ 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error(dopaT('cartReadError','Could not read the cart.'));
    return response.json();
  }

  function syncCartCount(cart) {
    const count = Number(cart?.item_count || 0);
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = String(count);
      const link = node.closest('a');
      if (link) link.setAttribute('aria-label', dopaBagLabel(count));
    });
  }

  const dopaSystemPropertyKeys = new Set(['Pre-order delivery', 'Format']);
  const activePropertyEntries = (properties = {}) => Object.entries(properties || {}).filter(([, value]) => value != null && String(value).trim() !== '');
  const hasOnlyDopaSystemProperties = (properties = {}) => activePropertyEntries(properties).every(([key]) => dopaSystemPropertyKeys.has(key) || key.startsWith('_dopa_'));
  const sellingPlanIdForLine = (item) => String(item?.selling_plan_allocation?.selling_plan?.id || item?.selling_plan_allocation?.selling_plan?.name || '');
  const lineHasDiscountSplit = (item) => {
    if (Array.isArray(item?.line_level_discount_allocations) && item.line_level_discount_allocations.length > 0) return true;
    if (Array.isArray(item?.discounts) && item.discounts.length > 0) return true;
    const originalUnit = Number(item?.original_price);
    const finalUnit = Number(item?.final_price);
    const originalLine = Number(item?.original_line_price);
    const finalLine = Number(item?.final_line_price);
    return (Number.isFinite(originalUnit) && Number.isFinite(finalUnit) && originalUnit !== finalUnit) ||
      (Number.isFinite(originalLine) && Number.isFinite(finalLine) && originalLine !== finalLine);
  };

  async function changeCartLineByKey(key, quantity, properties = null) {
    const rootPath = window.Shopify?.routes?.root || '/';
    const body = { id:String(key), quantity:Math.max(0, Math.floor(Number(quantity) || 0)) };
    if (properties && Object.keys(properties).length) body.properties = properties;
    const response = await fetch(`${rootPath}cart/change.js`, {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' },
      body:JSON.stringify(body)
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw Object.assign(new Error(payload.description || payload.message || dopaT('cartUpdateError','Could not update your bag.')), { payload });
    return payload;
  }

  async function addFormToCart(form, button, status) {
    const variantInput = form.querySelector('[name="id"]:checked, select[name="id"], input[type="hidden"][name="id"]');
    const variantId = variantInput?.value ? String(variantInput.value) : '';
    if (!variantId) {
      setCommerceStatus(status, dopaT('chooseOption','Choose an available product option.'), true);
      return { ok:false, reason:'missing-variant' };
    }

    const original = button?.textContent || dopaT('addToCart','Add to cart');
    form.setAttribute('aria-busy', 'true');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'ADDING…';
    }
    setCommerceStatus(status, '');

    try {
      const rootPath = window.Shopify?.routes?.root || '/';
      const data = new FormData(form);
      const item = {
        // Keep Shopify IDs as strings. This avoids any risk of JavaScript integer precision loss.
        id: variantId,
        quantity: normalizeCartQuantity(data.get('quantity') || 1)
      };
      const properties = {};
      for (const [key, value] of data.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim() !== '') properties[match[1]] = String(value);
      }
      if (Object.keys(properties).length) item.properties = properties;
      const sellingPlan = data.get('selling_plan');
      const sellingPlanId = sellingPlan ? String(sellingPlan) : '';
      if (sellingPlanId) item.selling_plan = sellingPlanId;

      // Permanent duplicate-line protection for DOPA's non-personalised products.
      // Shopify can create separate cart lines when the same variant arrives through surfaces
      // with slightly different line-item properties. If the existing line contains only DOPA
      // system properties and is not a discount-split line, increase that line's quantity instead.
      let cart = null;
      let payload = null;
      if (hasOnlyDopaSystemProperties(properties)) {
        const before = await readCart();
        const mergeable = (before.items || []).filter((line) => {
          if (String(line.variant_id || line.id || '') !== variantId) return false;
          if (!hasOnlyDopaSystemProperties(line.properties || {})) return false;
          if (lineHasDiscountSplit(line)) return false;
          const lineSellingPlan = sellingPlanIdForLine(line);
          if (sellingPlanId && lineSellingPlan && lineSellingPlan !== sellingPlanId) return false;
          if (!sellingPlanId && lineSellingPlan) return false;
          return true;
        });

        if (mergeable.length) {
          const primary = mergeable[0];
          const totalQuantity = mergeable.reduce((sum, line) => sum + normalizeCartQuantity(line.quantity || 1), 0) + item.quantity;
          const canonicalProperties = { ...(primary.properties || {}), ...properties };
          cart = await changeCartLineByKey(primary.key, totalQuantity, canonicalProperties);

          // Clean up duplicate legacy lines created by older theme versions when it is safe to do so.
          // Never touch discount-split or personalised lines.
          for (const duplicate of mergeable.slice(1)) {
            const stillThere = (cart.items || []).find((line) => String(line.key || '') === String(duplicate.key || ''));
            if (!stillThere) continue;
            cart = await changeCartLineByKey(stillThere.key, 0);
          }
          payload = { items:[primary], merged:true };
        }
      }

      if (!cart) {
        const response = await fetch(`${rootPath}cart/add.js`, {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' },
          body:JSON.stringify({ items:[item] })
        });
        payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          const raw = String(payload.description || payload.message || 'This item could not be added.');
          const soldOut = /sold out|not enough|inventory|available/i.test(raw);
          if (soldOut && window.Shopify?.designMode) {
            setCommerceStatus(status, 'Shopify is rejecting this variant as unavailable. Verify Online Store publication, the active market, inventory location, and “Continue selling when out of stock” for advance-order SKUs.', true);
          } else {
            setCommerceStatus(status, soldOut ? 'This option is temporarily unavailable for online ordering.' : raw, true);
          }
          if (button) button.textContent = soldOut ? 'UNAVAILABLE' : original;
          if (window.Shopify?.designMode) console.warn('[DOPA cart/add]', payload);
          window.setTimeout(() => {
            if (!button) return;
            button.textContent = original;
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }, 1800);
          form.removeAttribute('aria-busy');
          return { ok:false, payload };
        }
        cart = await readCart();
      }

      syncCartCount(cart);
      if (button) {
        button.textContent = 'ADDED ✓';
        button.classList.add('is-added');
      }
      setCommerceStatus(status, payload?.merged ? dopaT('quantityUpdated','Quantity updated in cart.') : dopaT('addedToCart','Added to cart.'));
      document.dispatchEvent(new CustomEvent('dopa:cart-updated', { detail: { cart, source:payload?.merged ? 'merge-add' : 'add' } }));
      document.dispatchEvent(new CustomEvent('dopa:cart-added', { detail: { cart, item: payload } }));
      window.setTimeout(() => {
        if (!button) return;
        button.textContent = original;
        button.classList.remove('is-added');
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }, 1300);
      form.removeAttribute('aria-busy');
      return { ok:true, cart, payload };
    } catch (error) {
      if (button) {
        button.textContent = original;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
      const raw = String(error?.payload?.description || error?.message || dopaT('cartError','Could not reach the cart. Please try again.'));
      const soldOut = /sold out|not enough|inventory|available/i.test(raw);
      setCommerceStatus(status, soldOut ? 'This option is temporarily unavailable for online ordering.' : raw, true);
      if (window.Shopify?.designMode) console.error('[DOPA cart add/merge error]', error);
      form.removeAttribute('aria-busy');
      return { ok:false, error };
    }
  }

  function bindQuickAdd() { /* AJAX submit is delegated at document level so dynamically rendered cards work automatically. */ }
  function bindMainProductForms() { /* AJAX submit is delegated at document level so Theme Editor section reloads remain safe. */ }

  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : event.target?.closest?.('form');
    if (!form || !form.matches('.js-quick-add, .js-product-form, .pdp-final-product-form')) return;
    if (!window.fetch || !window.FormData) return;
    event.preventDefault();
    const button = event.submitter || form.querySelector('[data-product-submit], button[type="submit"]');
    const status = form.querySelector('[data-product-form-status], [data-quick-add-status], [data-kit-status]');
    if (!button || button.disabled) return;
    await addFormToCart(form, button, status);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target || document;
    bindProductVariantUI(root);
  });

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reducedMotion) {
    document.querySelectorAll('[data-tilt]').forEach((card) => {
      const max = 8;
      const reset = () => {
        card.classList.remove('is-tilting');
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
        card.style.setProperty('--tz', '0px');
        card.style.setProperty('--mx', '50%');
        card.style.setProperty('--my', '50%');
      };
      reset();
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const px = (event.clientX - rect.left) / rect.width;
        const py = (event.clientY - rect.top) / rect.height;
        const ry = (px - .5) * (max * 2);
        const rx = (.5 - py) * (max * 2);
        card.classList.add('is-tilting');
        card.style.setProperty('--rx', `${rx.toFixed(2)}deg`);
        card.style.setProperty('--ry', `${ry.toFixed(2)}deg`);
        card.style.setProperty('--tz', '8px');
        card.style.setProperty('--mx', `${(px * 100).toFixed(1)}%`);
        card.style.setProperty('--my', `${(py * 100).toFixed(1)}%`);
      });
      card.addEventListener('pointerleave', reset);
      card.addEventListener('pointercancel', reset);
    });
  }



  document.querySelectorAll('[data-dopa-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-slide]')];
    const dots = [...slider.querySelectorAll('[data-slide-to]')];
    const prev = slider.querySelector('[data-slide-prev]');
    const next = slider.querySelector('[data-slide-next]');
    const interval = Math.max(4000, Number(slider.dataset.autoplay) || 6000);
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    let timer = null;
    let touchX = null;

    const restartProgress = () => {
      slider.classList.remove('is-running');
      void slider.offsetWidth;
      slider.style.setProperty('--slider-duration', `${interval}ms`);
      if (!reduced) slider.classList.add('is-running');
    };
    const show = (nextIndex, userInitiated = false) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.inert = !active;
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        dot.tabIndex = active ? 0 : -1;
      });
      restartProgress();
      if (userInitiated) start();
    };
    const stop = () => { if (timer) window.clearInterval(timer); timer = null; slider.classList.remove('is-running'); };
    const start = () => {
      stop();
      restartProgress();
      if (!reduced) timer = window.setInterval(() => show(index + 1), interval);
    };
    dots.forEach((dot) => {
      dot.addEventListener('click', () => show(Number(dot.dataset.slideTo), true));
      dot.addEventListener('keydown', (event) => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = index - 1;
        if (event.key === 'ArrowRight') nextIndex = index + 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = slides.length - 1;
        show(nextIndex, true);
        dots[index]?.focus();
      });
    });
    prev?.addEventListener('click', () => show(index - 1, true));
    next?.addEventListener('click', () => show(index + 1, true));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', (event) => { if (!slider.contains(event.relatedTarget)) start(); });
    slider.addEventListener('touchstart', (event) => { touchX = event.changedTouches[0]?.clientX ?? null; stop(); }, { passive:true });
    slider.addEventListener('touchend', (event) => {
      if (touchX === null) return start();
      const endX = event.changedTouches[0]?.clientX ?? touchX;
      const delta = endX - touchX;
      touchX = null;
      if (Math.abs(delta) > 45) show(index + (delta < 0 ? 1 : -1), true); else start();
    }, { passive:true });
    show(0);
    start();
  });


  // V18 product media viewer: thumbnail rail + keyboard + arrows.
  document.querySelectorAll('[data-pdp-media-viewer]').forEach((viewer) => {
    const thumbs = [...viewer.querySelectorAll('[data-pdp-media-thumb]')];
    const panels = [...viewer.querySelectorAll('[data-pdp-media-panel]')];
    const prev = viewer.querySelector('[data-pdp-media-prev]');
    const next = viewer.querySelector('[data-pdp-media-next]');
    const current = viewer.querySelector('[data-pdp-media-current]');
    if (!panels.length) return;
    let index = 0;
    const show = (rawIndex, focusThumb = false, revealThumb = false) => {
      index = (rawIndex + panels.length) % panels.length;
      panels.forEach((panel, i) => {
        const active = i === index;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        panel.querySelectorAll('video').forEach((video) => { if (!active && !video.paused) video.pause(); });
      });
      thumbs.forEach((thumb, i) => {
        const active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        thumb.tabIndex = active ? 0 : -1;
      });
      if (current) current.textContent = String(index + 1);
      if (focusThumb) thumbs[index]?.focus();
      if (revealThumb && window.innerWidth <= 1000 && thumbs[index]) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        thumbs[index].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block:'nearest', inline:'center' });
      }
    };
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => show(i, false, true));
      thumb.addEventListener('keydown', (event) => {
        if (!['ArrowUp','ArrowDown','ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') return show(0, true, true);
        if (event.key === 'End') return show(panels.length - 1, true, true);
        const delta = event.key === 'ArrowUp' || event.key === 'ArrowLeft' ? -1 : 1;
        show(index + delta, true, true);
      });
    });
    prev?.addEventListener('click', () => show(index - 1, false, true));
    next?.addEventListener('click', () => show(index + 1, false, true));
    show(0);
  });

  document.querySelectorAll('[data-mobile-add]').forEach((button) => {
    button.addEventListener('click', () => {
      const form = document.querySelector('.main-product .product-form');
      if (!form) return;
      const submit = form.querySelector('[data-product-submit]');
      const scrollOnly = button.getAttribute('data-scroll-only') === 'true' || !submit || submit.disabled;
      if (!scrollOnly) {
        if (form.requestSubmit) form.requestSubmit(submit); else submit.click();
        return;
      }
      form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center' });
      window.setTimeout(() => form.querySelector('button:not([disabled]), select, input')?.focus({ preventScroll:true }), 450);
    });
  });


  document.querySelectorAll('[data-kit-builder]').forEach((builder) => {
    const inputs = [...builder.querySelectorAll('[data-kit-item]')];
    const addButton = builder.querySelector('[data-kit-add]');
    const countNode = builder.querySelector('[data-kit-count]');
    const totalNode = builder.querySelector('[data-kit-total]');
    const summaryNode = builder.querySelector('[data-kit-summary]');
    const status = builder.querySelector('[data-kit-status]');
    const presetButtons = [...builder.querySelectorAll('[data-kit-preset]')];
    const min = Number(builder.dataset.kitMin || 2);
    const max = Number(builder.dataset.kitMax || 4);
    const currency = builder.dataset.kitCurrency || 'INR';
    const money = (cents) => {
      const amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency }).format(amount);
      } catch (_) {
        return `${currency} ${amount.toFixed(2)}`;
      }
    };
    const isUnavailable = (input) => input.closest('.kit-option')?.classList.contains('is-unavailable');
    const update = () => {
      const selected = inputs.filter((input) => input.checked);
      const subtotal = selected.reduce((sum, input) => sum + Number(input.dataset.priceCents || 0), 0);
      if (countNode) countNode.textContent = `${selected.length} selected`;
      if (totalNode) totalNode.textContent = money(subtotal);
      if (summaryNode) {
        summaryNode.textContent = selected.length
          ? selected.map((input) => `${String(input.dataset.kitState || '').toUpperCase()}: ${input.dataset.productName || 'DOPA'}`).join('  /  ')
          : `Choose at least ${min} states to build your day.`;
      }
      if (addButton) addButton.disabled = selected.length < min || selected.length > max;
      inputs.forEach((input) => {
        const option = input.closest('.kit-option');
        option?.classList.toggle('is-selected', input.checked);
        if (!input.checked) input.disabled = selected.length >= max || isUnavailable(input);
        else input.disabled = false;
      });
      if (status && selected.length > max) status.textContent = `Choose no more than ${max} products.`;
    };
    inputs.forEach((input) => input.addEventListener('change', update));
    presetButtons.forEach((button) => button.addEventListener('click', () => {
      const keys = String(button.dataset.kitPreset || '').split(',').map((key) => key.trim()).filter(Boolean);
      inputs.forEach((input) => {
        input.checked = false;
        input.disabled = !!isUnavailable(input);
      });
      const missing = [];
      keys.slice(0, max).forEach((key) => {
        const input = inputs.find((candidate) => candidate.dataset.kitKey === key);
        if (!input || isUnavailable(input)) missing.push(key);
        else input.checked = true;
      });
      update();
      presetButtons.forEach((candidate) => candidate.classList.toggle('is-active', candidate === button));
      if (status) status.textContent = missing.length
        ? 'Part of this routine needs options or is unavailable. Choose the closest available states below.'
        : 'Routine selected. Review the live subtotal, then add your day.';
    }));
    addButton?.addEventListener('click', async () => {
      const selected = inputs.filter((input) => input.checked);
      if (selected.length < min || selected.length > max) return update();
      addButton.disabled = true;
      const original = addButton.textContent;
      addButton.textContent = 'ADDING YOUR DAY...';
      if (status) status.textContent = '';
      const items = selected.map((input) => ({ id: String(input.value), quantity: 1, ...(input.dataset.preorder === 'true' ? { properties: { 'Pre-order delivery': 'Estimated 1\u20134 weeks' } } : {}) }));
      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items }) });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.description || payload.message || 'Your DOPA day could not be added.');
        const cart = await readCart();
        syncCartCount(cart);
        document.dispatchEvent(new CustomEvent('dopa:cart-updated', { detail: { cart, source:'build-day' } }));
        document.dispatchEvent(new CustomEvent('dopa:cart-added', { detail: { cart, source:'build-day' } }));
        addButton.textContent = 'YOUR DAY IS IN THE BAG';
        if (status) status.textContent = 'Your selected states are in the bag at their live Shopify prices.';
        window.setTimeout(() => { addButton.textContent = original; addButton.disabled = false; update(); }, 1800);
      } catch (error) {
        addButton.textContent = original;
        addButton.disabled = false;
        if (status) status.textContent = error.message || 'Your DOPA day could not be added.';
        update();
      }
    });
    update();
  });

})();

/* V25 route-safe PDP hardening */
(() => {
  const configNode = document.getElementById('DopaSafeProductRoutes');
  let config = {};
  try { config = configNode ? JSON.parse(configNode.textContent || '{}') : {}; } catch (_) { config = {}; }

  const aliasRules = [
    { key:'control', patterns:['/products/dopa-control','/products/dopa-control-gum','/products/control-craving-gum'] },
    { key:'white', patterns:['/products/dopa-white','/products/dopa-white-whitening-gum','/products/white-whitening-gum'] },
    { key:'jaw', patterns:['/products/dopa-jaw','/products/dopa-jaw-resistance-gum','/products/jaw-resistance-gum'] },
    { key:'driveShot', patterns:['/products/dopa-drive-shot','/products/drive-intimacy-shot'] },
    { key:'controlShot', patterns:['/products/dopa-control-shot','/products/control-shot'] },
    { key:'driveMint', patterns:['/products/dopa-drive-mint','/products/drive-intimacy-mint'] }
  ];

  const normalizePath = (value) => {
    if (!value) return '';
    try { return new URL(value, window.location.origin).pathname.replace(/\/+$/, '').toLowerCase(); }
    catch (_) { return String(value).split('?')[0].replace(/\/+$/, '').toLowerCase(); }
  };

  const rewriteSafeLinks = (root = document) => {
    root.querySelectorAll('a[href]').forEach((link) => {
      if (link.dataset.dopaSafeBound === 'true') return;
      const href = link.getAttribute('href') || '';
      const path = normalizePath(href);
      let resolved = '';
      for (const rule of aliasRules) {
        if (!rule.patterns.some((pattern) => path === pattern)) continue;
        const entry = config?.[rule.key] || {};
        resolved = entry.live || entry.safe || '';
        break;
      }
      if (resolved) {
        link.setAttribute('href', resolved);
        link.dataset.dopaSafeBound = 'true';
      }
    });
  };
  rewriteSafeLinks(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      if (node.matches?.('a[href]')) rewriteSafeLinks(node.parentElement || document);
      else rewriteSafeLinks(node);
    }));
  });
  observer.observe(document.documentElement, { childList:true, subtree:true });

  document.querySelectorAll('[data-safe-pdp]').forEach((pdp) => {
    const select = pdp.querySelector('[data-safe-variant-select]');
    const price = pdp.querySelector('[data-safe-price]');
    const compare = pdp.querySelector('[data-safe-compare]');
    const submit = pdp.querySelector('[data-safe-submit]');
    const dynamicCheckout = pdp.querySelector('[data-dynamic-checkout]');
    if (!select) return;
    const update = () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        if (option.dataset.compare) { compare.textContent = option.dataset.compare; compare.hidden = false; }
        else { compare.textContent = ''; compare.hidden = true; }
      }
      if (submit) {
        const isPreorder = !!pdp.querySelector('[name="properties[Pre-order delivery]"]');
        const available = option.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? dopaT('addToCart','Add to cart') : (isPreorder ? dopaT('preorderUnavailable','Pre-order unavailable') : dopaT('soldOut','Sold out'));
      }
      if (dynamicCheckout) dynamicCheckout.hidden = option.dataset.available !== 'true';
    };
    select.addEventListener('change', update);
    update();
  });
})();

/* DOPA V29 — polish interactions */
(() => {
  const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  // Keep cart count semantics in sync with AJAX additions.
  document.addEventListener('dopa:cart-added', (event) => {
    const count = Number(event.detail?.cart?.item_count || 0);
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = String(count);
      const link = node.closest('a');
      if (link) link.setAttribute('aria-label', dopaBagLabel(count));
    });
  });

  // Swipe support for the PDP gallery on touch devices without changing keyboard controls.
  document.querySelectorAll('[data-pdp-media-viewer]').forEach((viewer) => {
    const stage = viewer.querySelector('.pdp-media-stage');
    const prev = viewer.querySelector('[data-pdp-media-prev]');
    const next = viewer.querySelector('[data-pdp-media-next]');
    if (!stage || !prev || !next || stage.dataset.swipeBound === 'true') return;
    stage.dataset.swipeBound = 'true';
    let startX = null;
    let startY = null;
    stage.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') return;
      startX = event.clientX;
      startY = event.clientY;
    }, { passive:true });
    stage.addEventListener('pointerup', (event) => {
      if (startX === null || startY === null) return;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      startX = null;
      startY = null;
      if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      (dx < 0 ? next : prev).click();
    }, { passive:true });
  });

  // If the viewport becomes desktop-sized while the mobile menu is open, release page scroll.
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 900) return;
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    document.body.classList.remove('menu-open');
    document.querySelector('[data-menu-open]')?.setAttribute('aria-expanded', 'false');
  }, { passive:true });

  // Make horizontal thumbnail rails feel intentional on keyboard and touch.
  document.querySelectorAll('.pdp-media-thumbs').forEach((rail) => {
    rail.addEventListener('wheel', (event) => {
      if (window.innerWidth > 1000 || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
      event.preventDefault();
      rail.scrollBy({ left:event.deltaY, behavior:prefersReducedMotion ? 'auto' : 'smooth' });
    }, { passive:false });
  });
})();

/* DOPA V39 — Gate 2 commerce drawer + line integrity */
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const panel = drawer.querySelector('.dopa-cart-drawer-panel');
  const linesNode = drawer.querySelector('[data-cart-drawer-lines]');
  const emptyNode = drawer.querySelector('[data-cart-drawer-empty]');
  const footerNode = drawer.querySelector('[data-cart-drawer-footer]');
  const totalNode = drawer.querySelector('[data-cart-drawer-total]');
  const statusNode = drawer.querySelector('[data-cart-drawer-status]');
  const currency = drawer.dataset.currency || 'INR';
  const mediaMapNode = document.getElementById('DopaCartMediaMap');
  let dopaMediaMap = {};
  try { dopaMediaMap = mediaMapNode ? JSON.parse(mediaMapNode.textContent || '{}') : {}; } catch (_) { dopaMediaMap = {}; }
  const dopaFallbackMedia = (item) => {
    const title = String(item?.product_title || item?.title || '').toLowerCase();
    const handle = String(item?.handle || item?.product_handle || item?.url || '').toLowerCase();
    const haystack = `${handle} ${title}`;
    if (haystack.includes('iq300') && !haystack.includes('shot')) return dopaMediaMap.iq300;
    if (haystack.includes('kik') && !haystack.includes('shot')) return dopaMediaMap.kik;
    if (haystack.includes('calm')) return dopaMediaMap.calm;
    if (haystack.includes('dopa-max') || haystack.includes('max extreme') || (haystack.includes('max') && haystack.includes('mint'))) return dopaMediaMap.max;
    if (haystack.includes('luna')) return dopaMediaMap.luna;
    if (haystack.includes('glowmine')) return dopaMediaMap.glowmine;
    if (haystack.includes('multi') || haystack.includes('multivitamin')) return dopaMediaMap.multi;
    if (haystack.includes('white') && haystack.includes('gum')) return dopaMediaMap.white;
    if (haystack.includes('jaw') && haystack.includes('gum')) return dopaMediaMap.jaw;
    if (haystack.includes('control') && haystack.includes('shot')) return dopaMediaMap['control-shot'];
    if (haystack.includes('control')) return dopaMediaMap['control-gum'];
    if (haystack.includes('drive') && haystack.includes('shot')) return dopaMediaMap['drive-shot'];
    if (haystack.includes('drive')) return dopaMediaMap['drive-mint'];
    if ((haystack.includes('focus') || haystack.includes('iq300')) && haystack.includes('shot')) return dopaMediaMap['focus-shot'];
    if ((haystack.includes('energy') || haystack.includes('kik')) && haystack.includes('shot')) return dopaMediaMap['energy-shot'];
    if (haystack.includes('hydra')) return dopaMediaMap['hydra-shot'];
    if (haystack.includes('reset') && haystack.includes('shot')) return dopaMediaMap['reset-shot'];
    return '';
  };
  let lastFocused = null;
  let busy = false;

  const rootPath = () => window.Shopify?.routes?.root || '/';
  const money = (cents) => {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency }).format(amount);
    } catch (_) {
      return `${currency} ${amount.toFixed(2)}`;
    }
  };
  const syncCount = (cart) => {
    const count = Number(cart?.item_count || 0);
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = String(count);
      const link = node.closest('a');
      if (link) link.setAttribute('aria-label', dopaBagLabel(count));
    });
  };
  const fetchCart = async () => {
    const response = await fetch(`${rootPath()}cart.js`, { headers:{ 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' } });
    if (!response.ok) throw new Error(dopaT('cartLoadError','Could not load your bag.'));
    return response.json();
  };
  const text = (tag, value, className) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    node.textContent = value == null ? '' : String(value);
    return node;
  };

  const render = (cart) => {
    syncCount(cart);
    if (!linesNode) return;
    linesNode.replaceChildren();
    const items = Array.isArray(cart?.items) ? cart.items : [];

    items.forEach((item) => {
      const article = document.createElement('article');
      article.className = 'dopa-cart-drawer-line';
      article.dataset.cartLineKey = String(item.key || '');

      const media = document.createElement('a');
      media.className = 'dopa-cart-drawer-media';
      media.href = item.url || '#';
      const imageUrl = item.featured_image?.url || item.image || dopaFallbackMedia(item) || '';
      if (imageUrl) {
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = item.product_title || item.title || 'DOPA product';
        img.loading = 'lazy';
        img.width = 180;
        img.height = 180;
        media.append(img);
      } else {
        const mark = document.createElement('span');
        mark.className = 'dopa-cart-media-monogram';
        mark.setAttribute('aria-hidden','true');
        mark.textContent = 'D';
        media.append(mark);
      }

      const copy = document.createElement('div');
      copy.className = 'dopa-cart-drawer-copy';
      const titleLink = document.createElement('a');
      titleLink.href = item.url || '#';
      titleLink.append(text('strong', item.product_title || item.title || 'DOPA product'));
      copy.append(titleLink);
      if (item.variant_title && item.variant_title !== 'Default Title') copy.append(text('small', item.variant_title));
      const preorder = item.properties?.['Pre-order delivery'];
      if (preorder) copy.append(text('span', preorder));

      const qty = document.createElement('div');
      qty.className = 'dopa-cart-drawer-qty';
      qty.setAttribute('aria-label', `Quantity controls for ${item.product_title || item.title || 'item'}`);
      const makeAction = (label, action, visible) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.cartLineAction = action;
        button.dataset.cartLineKey = String(item.key || '');
        button.dataset.cartLineQuantity = String(item.quantity || 1);
        button.setAttribute('aria-label', label);
        button.textContent = visible;
        return button;
      };
      qty.append(makeAction('Decrease quantity', 'decrease', '−'));
      qty.append(text('b', item.quantity || 1));
      qty.append(makeAction('Increase quantity', 'increase', '+'));
      const remove = makeAction(`${dopaT('remove','Remove')} ${item.product_title || item.title || ''}`.trim(), 'remove', dopaT('remove','Remove'));
      remove.classList.add('dopa-cart-drawer-remove');
      qty.append(remove);
      copy.append(qty);

      article.append(media, copy, text('strong', money(item.final_line_price ?? item.line_price), 'dopa-cart-drawer-price'));
      linesNode.append(article);
    });

    if (emptyNode) emptyNode.hidden = items.length > 0;
    if (footerNode) footerNode.hidden = items.length === 0;
    if (totalNode) totalNode.textContent = money(cart?.total_price || 0);
    document.dispatchEvent(new CustomEvent('dopa:cart-rendered', { detail:{ cart } }));
  };

  const focusables = () => [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')];
  const open = async (cart = null) => {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    if (statusNode) { statusNode.textContent = ''; statusNode.removeAttribute('role'); statusNode.setAttribute('aria-live','polite'); }
    try {
      const latest = cart || await fetchCart();
      render(latest);
    } catch (error) {
      if (statusNode) { statusNode.textContent = error.message || dopaT('cartLoadError','Could not load your bag.'); statusNode.setAttribute('role','alert'); statusNode.setAttribute('aria-live','assertive'); }
    }
    panel?.focus();
  };
  const close = () => {
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    lastFocused?.focus?.();
  };

  drawer.querySelectorAll('[data-cart-drawer-close]').forEach((node) => node.addEventListener('click', close));
  document.querySelectorAll('[data-cart-drawer-open]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (document.body.classList.contains('template-cart')) return;
      event.preventDefault();
      open();
    });
  });
  drawer.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') return close();
    if (event.key !== 'Tab') return;
    const nodes = focusables();
    if (!nodes.length) return;
    const first = nodes[0], last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  const changeLine = async (key, quantity) => {
    if (busy || !key) return;
    busy = true;
    drawer.setAttribute('aria-busy', 'true');
    if (statusNode) { statusNode.textContent = quantity === 0 ? dopaT('cartRemoving','Removing item...') : dopaT('cartUpdating','Updating bag...'); statusNode.removeAttribute('role'); statusNode.setAttribute('aria-live','polite'); }
    try {
      const response = await fetch(`${rootPath()}cart/change.js`, {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' },
        body:JSON.stringify({ id:String(key), quantity:Math.max(0, Math.floor(Number(quantity) || 0)) })
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || payload.message || dopaT('cartUpdateError','Could not update your bag.'));
      render(payload);
      document.dispatchEvent(new CustomEvent('dopa:cart-updated', { detail:{ cart:payload, source:'drawer-change' } }));
      if (statusNode) { statusNode.textContent = quantity === 0 ? dopaT('cartRemoved','Item removed.') : dopaT('cartUpdated','Bag updated.'); statusNode.removeAttribute('role'); statusNode.setAttribute('aria-live','polite'); }
      if (document.body.classList.contains('template-cart')) window.setTimeout(() => window.location.reload(), 250);
    } catch (error) {
      if (statusNode) { statusNode.textContent = error.message || dopaT('cartUpdateError','Could not update your bag.'); statusNode.setAttribute('role','alert'); statusNode.setAttribute('aria-live','assertive'); }
    } finally {
      busy = false;
      drawer.removeAttribute('aria-busy');
    }
  };

  drawer.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-line-action]');
    if (!button) return;
    const key = button.dataset.cartLineKey || '';
    const current = Math.max(1, Math.floor(Number(button.dataset.cartLineQuantity) || 1));
    const action = button.dataset.cartLineAction;
    if (action === 'increase') changeLine(key, current + 1);
    if (action === 'decrease') changeLine(key, Math.max(0, current - 1));
    if (action === 'remove') changeLine(key, 0);
  });

  document.addEventListener('dopa:cart-added', (event) => open(event.detail?.cart || null));
  document.addEventListener('dopa:cart-updated', (event) => {
    if (event.detail?.cart) render(event.detail.cart);
  });
})();


/* DOPA V40 — Gate 3 mobile conversion controller */
(() => {
  const bar = document.querySelector('[data-mobile-buy]');
  const form = document.querySelector('.main-product .product-form');
  if (!bar || !form) return;

  const submit = form.querySelector('[data-product-submit]');
  const media = window.matchMedia('(max-width: 800px)');
  let ticking = false;

  const interactiveFocus = () => {
    const active = document.activeElement;
    return !!(active && form.contains(active) && active.matches('input,select,textarea,button'));
  };

  const syncVisibility = () => {
    ticking = false;
    if (!media.matches || !submit) {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
      return;
    }
    const formRect = form.getBoundingClientRect();
    const submitRect = submit.getBoundingClientRect();
    const submitVisible = submitRect.bottom > 0 && submitRect.top < window.innerHeight;
    const userReachedPurchase = formRect.top < window.innerHeight * 0.35;
    const blocked = interactiveFocus() || document.body.classList.contains('cart-drawer-open') || document.body.classList.contains('menu-open');
    const shouldShow = userReachedPurchase && !submitVisible && !blocked;
    bar.classList.toggle('is-visible', shouldShow);
    bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  };

  const queue = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(syncVisibility);
  };

  window.addEventListener('scroll', queue, { passive:true });
  window.addEventListener('resize', queue, { passive:true });
  media.addEventListener?.('change', queue);
  document.addEventListener('focusin', queue);
  document.addEventListener('focusout', () => window.setTimeout(queue, 0));
  document.addEventListener('dopa:cart-added', queue);
  document.addEventListener('dopa:cart-updated', queue);
  queue();
})();


/* DOPA V42 - Gate 5 AOV controller */
(() => {
  document.querySelectorAll('[data-quantity-presets]').forEach((group) => {
    const form = group.closest('form');
    const quantity = form?.querySelector('input[name="quantity"]');
    const buttons = [...group.querySelectorAll('[data-quantity-preset]')];
    if (!quantity || !buttons.length) return;
    const sync = () => {
      const current = Math.max(1, Math.floor(Number(quantity.value) || 1));
      buttons.forEach((button) => button.classList.toggle('is-active', Number(button.dataset.quantityPreset) === current));
    };
    buttons.forEach((button) => button.addEventListener('click', () => {
      quantity.value = String(Math.max(1, Math.floor(Number(button.dataset.quantityPreset) || 1)));
      quantity.dispatchEvent(new Event('change', { bubbles:true }));
      sync();
    }));
    quantity.addEventListener('input', sync);
    quantity.addEventListener('change', sync);
    sync();
  });

  const zone = document.querySelector('[data-cart-aov]');
  if (!zone) return;
  const candidates = [...zone.querySelectorAll('[data-aov-candidate]')];
  const ruleNode = zone.querySelector('[data-cart-aov-rule]');
  const byKey = new Map(candidates.map((candidate) => [candidate.dataset.aovKey, candidate]));
  const idToKey = new Map(candidates.map((candidate) => [String(candidate.dataset.aovProductId || ''), candidate.dataset.aovKey]));

  const hideAll = () => {
    candidates.forEach((candidate) => { candidate.hidden = true; });
    zone.hidden = true;
  };
  const show = (key, rule) => {
    const candidate = byKey.get(key);
    if (!candidate || candidate.dataset.aovAvailable !== 'true') return hideAll();
    candidates.forEach((node) => { node.hidden = node !== candidate; });
    if (ruleNode) ruleNode.textContent = rule;
    zone.hidden = false;
  };
  const update = (cart) => {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const present = new Set();
    items.forEach((item) => {
      const key = idToKey.get(String(item.product_id || ''));
      if (key) present.add(key);
    });

    const has = (key) => present.has(key);
    const completedPair = (has('calm') && has('luna')) || (has('iq') && has('max')) || (has('kik') && has('max'));
    if (completedPair) return hideAll();

    if (has('calm') && !has('luna') && !has('iq') && !has('kik') && !has('max')) return show('luna', 'RESET + NIGHT');
    if (has('luna') && !has('calm') && !has('iq') && !has('kik') && !has('max')) return show('calm', 'NIGHT + RESET');
    if ((has('iq') || has('kik')) && !has('max') && !has('calm') && !has('luna')) return show('max', 'WORK MODE + FRESH');
    if (has('max') && !has('iq') && !has('kik') && !has('calm') && !has('luna')) return show('iq', 'FRESH + FOCUS');
    hideAll();
  };

  document.addEventListener('dopa:cart-rendered', (event) => update(event.detail?.cart));
  document.addEventListener('dopa:cart-updated', (event) => update(event.detail?.cart));
})();


/* DOPA V43 — Gate 6 onsite recovery + state preference controller */
(() => {
  const allowedStates = new Set(['focus','energy','reset','night','fresh']);
  const safeState = (value) => allowedStates.has(String(value || '').toLowerCase()) ? String(value).toLowerCase() : '';
  const storageKey = 'dopa_last_state';
  const storeState = (state) => {
    const clean = safeState(state);
    if (!clean) return;
    try { window.localStorage.setItem(storageKey, clean); } catch (_) {}
  };
  const readState = () => {
    try { return safeState(window.localStorage.getItem(storageKey)); } catch (_) { return ''; }
  };

  const funnel = document.querySelector('[data-state-funnel]');
  if (funnel) storeState(funnel.dataset.stateFunnel);

  document.addEventListener('click', (event) => {
    const stateLink = event.target.closest('[data-state-funnel-link][data-dopa-state]');
    if (stateLink) storeState(stateLink.dataset.dopaState);
  });

  const remembered = readState();
  if (!remembered) return;

  document.querySelectorAll('[data-dopa-state-select]').forEach((select) => {
    const option = [...select.options].find((item) => String(item.value || '').includes(`dopa-interest-${remembered}`));
    if (option) select.value = option.value;
  });

  const resume = document.querySelector('[data-dopa-resume-state]');
  if (!resume) return;
  const matchingDoor = document.querySelector(`[data-state-router] [data-state-funnel-link][data-dopa-state="${remembered}"]`);
  if (!matchingDoor) return;
  resume.href = matchingDoor.href;
  resume.textContent = `CONTINUE ${remembered.toUpperCase()} →`;
  resume.hidden = false;
})();

/* DOPA V44 — Gate 7 measurement engine
   Privacy rule: this theme publishes non-PII custom interaction events into Shopify's
   customer-event bus. Downstream app/custom pixels remain responsible for consent,
   destination mapping, deduplication and platform configuration. */
(() => {
  const contextNode = document.getElementById('DopaMeasurementContext');
  let baseContext = {};
  try { baseContext = contextNode ? JSON.parse(contextNode.textContent || '{}') : {}; } catch (_) { baseContext = {}; }

  const safeText = (value, max = 120) => String(value == null ? '' : value).trim().slice(0, max);
  const safeNumber = (value) => Number.isFinite(Number(value)) ? Number(value) : 0;
  const pathOnly = (href) => {
    try { return new URL(href, window.location.origin).pathname; } catch (_) { return ''; }
  };

  const scaleConfigNode = document.getElementById('DopaScaleConfig');
  let scaleConfig = {};
  try { scaleConfig = scaleConfigNode ? JSON.parse(scaleConfigNode.textContent || '{}') : {}; } catch (_) { scaleConfig = {}; }
  const campaignContext = () => {
    if (scaleConfig.capture_utm === false) return {};
    const keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','snap_campaign_id'];
    let stored = {};
    try { stored = JSON.parse(sessionStorage.getItem('dopa_campaign_v1') || '{}') || {}; } catch (_) { stored = {}; }
    try {
      const params = new URLSearchParams(window.location.search);
      const current = {};
      keys.forEach((key) => {
        if (!params.has(key)) return;
        const value = safeText(params.get(key), key === 'utm_campaign' ? 120 : 80);
        if (value) current[key] = value;
      });
      if (Object.keys(current).length) {
        stored = { ...stored, ...current };
        sessionStorage.setItem('dopa_campaign_v1', JSON.stringify(stored));
      }
    } catch (_) {}
    return keys.reduce((out, key) => {
      const value = safeText(stored[key], key === 'utm_campaign' ? 120 : 80);
      if (value) out[key] = value;
      return out;
    }, {});
  };

  const pageContext = () => ({
    measurement_version: safeText(baseContext.measurement_version || 'G7-V2', 24),
    theme_version: safeText(baseContext.theme_version || 'V49', 24),
    page_type: safeText(baseContext.page_type, 40),
    template_name: safeText(baseContext.template_name, 60),
    page_handle: safeText(baseContext.page_handle, 80),
    product_id: baseContext.product_id == null ? '' : safeText(baseContext.product_id, 40),
    product_handle: safeText(baseContext.product_handle, 100),
    currency: safeText(baseContext.currency, 8),
    path: safeText(window.location.pathname, 160),
    ...campaignContext()
  });

  const publish = (eventName, data = {}) => {
    const name = eventName.startsWith('dopa:') ? eventName : `dopa:${eventName}`;
    const payload = { ...pageContext(), ...data };
    try {
      const result = window.Shopify?.analytics?.publish?.(name, payload);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (_) {}
    if (window.Shopify?.designMode) {
      document.dispatchEvent(new CustomEvent('dopa:measurement-debug', { detail:{ name, payload } }));
    }
  };
  window.DOPAAnalytics = Object.freeze({ publish, context: pageContext });

  const stateLanding = document.querySelector('[data-state-funnel]');
  if (stateLanding) {
    publish('state_landing_viewed', {
      state: safeText(stateLanding.dataset.stateFunnel, 24),
      surface: 'state-landing'
    });
  }

  const kit = document.querySelector('[data-kit-builder]');
  if (kit) publish('build_day_viewed', { surface:'build-your-day' });

  const recoveryState = (container) => {
    const direct = safeText(container?.dataset?.dopaState || '', 24);
    if (direct) return direct;
    const select = container?.querySelector?.('[data-dopa-state-select]');
    const selectedValue = String(select?.value || '');
    const match = selectedValue.match(/dopa-interest-([a-z0-9-]+)/i);
    return safeText(match?.[1] || '', 24);
  };

  document.querySelectorAll('[data-dopa-capture-confirmed]').forEach((marker) => {
    const container = marker.closest('[data-dopa-recovery-capture], [data-dopa-source="home"]');
    if (!container) return;
    publish('recovery_capture_confirmed', {
      // State pages have a durable state slug in the DOM. The homepage selector may reset after Shopify reloads,
      // so confirmed homepage captures intentionally omit state rather than misattribute a lead.
      state: safeText(container.dataset.dopaState || '', 24),
      source: safeText(container.dataset.dopaSource || 'unknown', 40)
    });
  });

  const publishedRecoveryStarts = new WeakSet();
  document.addEventListener('focusin', (event) => {
    const input = event.target.closest?.('[data-dopa-recovery-capture] input[type="email"], [data-dopa-source="home"] input[type="email"]');
    if (!input) return;
    const container = input.closest('[data-dopa-recovery-capture], [data-dopa-source="home"]');
    if (!container || publishedRecoveryStarts.has(container)) return;
    publishedRecoveryStarts.add(container);
    publish('recovery_capture_started', {
      state: recoveryState(container),
      source: safeText(container.dataset.dopaSource || 'unknown', 40)
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form) return;
    const recovery = form.closest('[data-dopa-recovery-capture], [data-dopa-source="home"]');
    if (recovery && form.querySelector('input[name="contact[email]"]')) {
      publish('recovery_capture_submit_attempted', {
        state: recoveryState(recovery),
        source: safeText(recovery.dataset.dopaSource || 'unknown', 40)
      });
    }
    if (form.closest('[data-state-funnel]') && form.matches('.state-funnel-form')) {
      publish('state_quick_add_clicked', {
        state: safeText(form.closest('[data-state-funnel]')?.dataset.stateFunnel, 24),
        surface: 'state-landing'
      });
    }
  }, true);

  document.addEventListener('click', (event) => {
    const stateLink = event.target.closest?.('[data-state-funnel-link][data-dopa-state]');
    if (stateLink) {
      const surface = stateLink.closest('[data-state-router]') ? 'home-state-router' : (stateLink.closest('[data-state-funnel]') ? 'state-landing' : 'other');
      publish('state_selected', {
        state: safeText(stateLink.dataset.dopaState, 24),
        surface,
        destination_path: pathOnly(stateLink.href)
      });
    }

    const quantityPreset = event.target.closest?.('[data-quantity-preset]');
    if (quantityPreset) {
      publish('quantity_preset_selected', {
        quantity: safeNumber(quantityPreset.dataset.quantityPreset),
        surface: quantityPreset.closest('.main-product') ? 'pdp' : 'other'
      });
    }

    const kitPreset = event.target.closest?.('[data-kit-preset]');
    if (kitPreset) {
      publish('build_day_preset_selected', {
        preset: safeText(kitPreset.dataset.kitPreset, 100),
        surface: 'build-your-day'
      });
    }

    const kitAdd = event.target.closest?.('[data-kit-add]');
    if (kitAdd) {
      const builder = kitAdd.closest('[data-kit-builder]');
      const selected = builder ? [...builder.querySelectorAll('input[type="checkbox"]:checked')] : [];
      publish('build_day_add_clicked', {
        selected_count: selected.length,
        states: selected.map((input) => safeText(input.dataset.kitState, 24)).filter(Boolean).slice(0, 4).join('|')
      });
    }

    const aovCandidate = event.target.closest?.('[data-aov-candidate]');
    if (aovCandidate && !aovCandidate.hidden) {
      const action = event.target.closest('button') ? 'add' : (event.target.closest('a') ? 'details' : 'candidate');
      publish('aov_offer_clicked', {
        offer_key: safeText(aovCandidate.dataset.aovKey, 24),
        state: safeText(aovCandidate.dataset.dopaState, 24),
        action,
        rule: safeText(aovCandidate.closest('[data-cart-aov]')?.querySelector('[data-cart-aov-rule]')?.textContent, 60)
      });
    }

    const resumeState = event.target.closest?.('[data-dopa-resume-state]');
    if (resumeState && !resumeState.hidden) {
      publish('resume_state_clicked', { destination_path: pathOnly(resumeState.href) });
    }

    const resumeBag = event.target.closest?.('[data-dopa-resume-bag]');
    if (resumeBag) publish('resume_bag_clicked', { surface:'home-state-router' });

    const checkout = event.target.closest?.('[data-dopa-checkout-cta], button[name="checkout"], a[href*="/checkout"]');
    if (checkout) {
      publish('checkout_cta_clicked', {
        surface: safeText(checkout.dataset?.dopaCheckoutCta || (checkout.closest('[data-cart-drawer]') ? 'cart-drawer' : 'cart'), 40)
      });
    }
  }, true);

  document.addEventListener('dopa:cart-added', (event) => {
    const detail = event.detail || {};
    const cart = detail.cart || {};
    if (detail.source === 'build-day') {
      publish('build_day_added', {
        item_count: safeNumber(cart.item_count),
        subtotal_cents: safeNumber(cart.total_price),
        currency: safeText(cart.currency || baseContext.currency, 8)
      });
    }
    publish('cart_drawer_opened', {
      trigger: detail.source === 'build-day' ? 'build-day-add' : 'add-to-cart',
      item_count: safeNumber(cart.item_count),
      subtotal_cents: safeNumber(cart.total_price)
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest?.('[data-cart-drawer-open]')) {
      publish('cart_drawer_opened', { trigger:'explicit-open' });
    }
  });

  const aovZone = document.querySelector('[data-cart-aov]');
  if (aovZone) {
    let lastOffer = '';
    const checkAov = () => {
      if (aovZone.hidden) { lastOffer = ''; return; }
      const candidate = [...aovZone.querySelectorAll('[data-aov-candidate]')].find((node) => !node.hidden);
      if (!candidate) { lastOffer = ''; return; }
      const rule = safeText(aovZone.querySelector('[data-cart-aov-rule]')?.textContent, 60);
      const key = `${safeText(candidate.dataset.aovKey, 24)}|${rule}`;
      if (key === lastOffer) return;
      lastOffer = key;
      publish('aov_offer_viewed', {
        offer_key: safeText(candidate.dataset.aovKey, 24),
        state: safeText(candidate.dataset.dopaState, 24),
        rule
      });
    };
    const observer = new MutationObserver(checkAov);
    observer.observe(aovZone, { attributes:true, subtree:true, attributeFilter:['hidden'] });
    document.addEventListener('dopa:cart-rendered', checkAov);
    document.addEventListener('dopa:cart-updated', checkAov);
    checkAov();
  }
})();



/* DOPA V46 — Gate 9 Scale Lab
   One live experiment at a time. Off by default. Assignment is session-scoped,
   no customer identity is stored, and protected commerce/truth surfaces are excluded. */
(() => {
  const node = document.getElementById('DopaScaleConfig');
  if (!node) return;
  let config = {};
  try { config = JSON.parse(node.textContent || '{}') || {}; } catch (_) { config = {}; }
  if (!config.enabled) return;

  const safe = (value, max = 120) => String(value == null ? '' : value).trim().slice(0, max);
  const id = safe(config.experiment_id, 80);
  const surface = safe(config.surface, 40);
  const splitB = Math.max(10, Math.min(90, Number(config.split_b) || 50));
  const allowed = {
    state_router_headline: '[data-scale-copy="state-router-headline"]',
    build_day_cta: '[data-scale-copy="build-day-cta"]',
    cart_aov_headline: '[data-scale-copy="cart-aov-headline"]'
  };
  const selector = allowed[surface];
  if (!id || !selector) return;

  const nodes = [...document.querySelectorAll(selector)];
  if (!nodes.length) return;

  const variantBCopy = safe(config.copies?.[surface], 140);
  if (!variantBCopy) return;
  const preview = safe(config.preview_variant, 8).toUpperCase();
  const key = `dopa_exp_v1:${id}`;
  let variant = '';

  if (window.Shopify?.designMode && (preview === 'A' || preview === 'B')) {
    variant = preview;
  } else {
    try { variant = safe(sessionStorage.getItem(key), 1).toUpperCase(); } catch (_) {}
    if (variant !== 'A' && variant !== 'B') {
      let draw = Math.random() * 100;
      try {
        if (window.crypto?.getRandomValues) {
          const bucket = new Uint32Array(1);
          window.crypto.getRandomValues(bucket);
          draw = (bucket[0] / 4294967296) * 100;
        }
      } catch (_) {}
      variant = draw < splitB ? 'B' : 'A';
      try { sessionStorage.setItem(key, variant); } catch (_) {}
    }
  }

  if (variant === 'B' && variantBCopy) {
    nodes.forEach((target) => { target.textContent = variantBCopy; });
  }

  document.documentElement.dataset.dopaExperiment = id;
  document.documentElement.dataset.dopaExperimentVariant = variant;
  document.documentElement.dataset.dopaExperimentSurface = surface;

  const meta = Object.freeze({
    experiment_id: id,
    experiment_surface: surface,
    experiment_variant: variant,
    split_b: splitB
  });
  const publish = (name, data = {}) => {
    const payload = { ...meta, ...data };
    if (window.Shopify?.designMode) {
      document.dispatchEvent(new CustomEvent('dopa:measurement-debug', { detail:{ name:`dopa:${name}`, payload:{ ...(window.DOPAAnalytics?.context?.() || {}), ...payload, preview:true } } }));
      return;
    }
    window.DOPAAnalytics?.publish?.(name, payload);
  };

  publish('experiment_exposed', { node_count:nodes.length });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (surface === 'state_router_headline' && target.closest('[data-state-funnel-link]')) {
      publish('experiment_action', { action:'state_selected', state:safe(target.closest('[data-state-funnel-link]')?.dataset?.dopaState, 24) });
    }
    if (surface === 'build_day_cta' && target.closest(selector)) {
      publish('experiment_action', { action:'build_day_cta_clicked' });
    }
    if (surface === 'cart_aov_headline' && target.closest('[data-aov-candidate]')) {
      publish('experiment_action', { action:'aov_candidate_clicked', state:safe(target.closest('[data-aov-candidate]')?.dataset?.dopaState, 24) });
    }
    if (target.closest('[data-dopa-checkout-cta], button[name="checkout"], a[href*="/checkout"]')) {
      publish('experiment_action', { action:'checkout_cta_clicked' });
    }
  }, true);

  document.addEventListener('dopa:cart-added', (event) => {
    const cart = event.detail?.cart || {};
    publish('experiment_action', {
      action:'cart_added',
      item_count:Number(cart.item_count) || 0,
      subtotal_cents:Number(cart.total_price) || 0
    });
  });

  window.DOPAScaleLab = Object.freeze({ ...meta, active:true });
})();



/* DOPA V46 — Gate 8 production preflight diagnostics (Theme Editor only) */
(() => {
  if (!window.Shopify?.designMode) return;
  const panel = document.querySelector('[data-dopa-launch-preflight]');
  if (!panel) return;
  const runtimeNode = panel.querySelector('[data-preflight-runtime]');
  const update = (kind, message) => {
    if (!runtimeNode) return;
    const item = document.createElement('li');
    item.textContent = `${kind}: ${String(message || 'Unknown runtime issue').slice(0, 180)}`;
    runtimeNode.append(item);
    panel.dataset.runtimeIssues = String(Number(panel.dataset.runtimeIssues || 0) + 1);
  };
  window.addEventListener('error', (event) => update('JS', event.message));
  window.addEventListener('unhandledrejection', (event) => update('Promise', event.reason?.message || event.reason));
})();


/* DOPA V51 - Shopify Markets localization discovery */
(() => {
  const configNode = document.getElementById('DopaLocalizationConfig');
  const form = document.getElementById('DopaLocalizationDiscoveryForm');
  const prompt = document.querySelector('[data-dopa-localization-prompt]');
  if (!configNode || !form || !prompt || window.Shopify?.designMode) return;

  let config;
  try { config = JSON.parse(configNode.textContent || '{}'); } catch (_) { return; }
  if (!config || config.mode === 'off') return;

  const now = Date.now();
  try {
    const manualUntil = Number(localStorage.getItem('dopa_localization_manual_until') || 0);
    if (manualUntil > now) return;
  } catch (_) {}

  const currentCountry = String(config.currentCountry || window.Shopify?.country || '').toUpperCase();
  const currentLanguage = String(config.currentLanguage || window.Shopify?.language || '').toLowerCase();
  const availableCountries = new Set((config.countries || []).map((value) => String(value).toUpperCase()));
  const availableLanguages = new Set((config.languages || []).map((value) => String(value).toLowerCase()));
  const root = window.Shopify?.routes?.root || '/';
  const params = new URLSearchParams();
  if (availableCountries.size > 1) {
    params.set('country[enabled]', 'true');
    if (currentCountry) params.set('country[exclude]', currentCountry);
  }
  if (availableLanguages.size > 1) {
    params.set('language[enabled]', 'true');
    if (currentLanguage) params.set('language[exclude]', currentLanguage);
  }
  if (![...params.keys()].length) return;

  const countryInput = form.querySelector('[data-dopa-discovery-country]');
  const languageInput = form.querySelector('[data-dopa-discovery-language]');
  const card = prompt.querySelector('.dopa-localization-card');
  const targetNode = prompt.querySelector('[data-dopa-localization-target]');
  const accept = prompt.querySelector('[data-dopa-localization-accept]');
  const dismissButtons = [...prompt.querySelectorAll('[data-dopa-localization-dismiss]')];
  let lastFocused = null;

  const rememberDismissal = () => {
    try { sessionStorage.setItem('dopa_localization_dismissed', '1'); } catch (_) {}
  };
  const hide = () => {
    prompt.hidden = true;
    prompt.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('localization-prompt-open');
    lastFocused?.focus?.();
  };
  const dismiss = () => { rememberDismissal(); hide(); };
  dismissButtons.forEach((button) => button.addEventListener('click', dismiss));
  prompt.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') dismiss();
  });

  const submit = (country, language) => {
    const targetCountry = availableCountries.has(String(country || '').toUpperCase()) ? String(country).toUpperCase() : currentCountry;
    const targetLanguage = availableLanguages.has(String(language || '').toLowerCase()) ? String(language).toLowerCase() : currentLanguage;
    if (!targetCountry && !targetLanguage) return;
    if (countryInput) countryInput.value = targetCountry || currentCountry;
    if (languageInput) languageInput.value = targetLanguage || currentLanguage;
    try { sessionStorage.setItem('dopa_localization_applied', `${targetCountry}|${targetLanguage}`); } catch (_) {}
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  };

  fetch(`${root}browsing_context_suggestions.json?${params.toString()}`, {
    headers:{ 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' },
    credentials:'same-origin'
  })
    .then((response) => response.ok ? response.json() : Promise.reject(new Error('localization unavailable')))
    .then((payload) => {
      const suggestion = Array.isArray(payload?.suggestions) ? payload.suggestions[0] : null;
      if (!suggestion?.parts) return;
      const countryPart = suggestion.parts.country || {};
      const languagePart = suggestion.parts.language || {};
      const targetCountry = availableCountries.has(String(countryPart.handle || '').toUpperCase()) ? String(countryPart.handle).toUpperCase() : currentCountry;
      const targetLanguage = availableLanguages.has(String(languagePart.handle || '').toLowerCase()) ? String(languagePart.handle).toLowerCase() : currentLanguage;
      const countryChanged = targetCountry && targetCountry !== currentCountry;
      const languageChanged = targetLanguage && targetLanguage !== currentLanguage;
      if (!countryChanged && !languageChanged) return;

      const signature = `${targetCountry}|${targetLanguage}`;
      try { if (sessionStorage.getItem('dopa_localization_applied') === signature) return; } catch (_) {}
      const confidence = Number(suggestion.confidence ?? Math.min(countryPart.confidence ?? 1, languagePart.confidence ?? 1));
      const targetName = [countryChanged ? (countryPart.name || targetCountry) : '', languageChanged ? (languagePart.name || targetLanguage) : ''].filter(Boolean).join(' - ');
      const threshold = Math.max(0.5, Math.min(1, Number(config.threshold) || 0.9));

      if (config.mode === 'auto' && confidence >= threshold) {
        submit(targetCountry, targetLanguage);
        return;
      }
      try { if (sessionStorage.getItem('dopa_localization_dismissed') === '1') return; } catch (_) {}
      if (targetNode) targetNode.textContent = targetName;
      if (accept) {
        const template = String(config.copy?.switchTo || 'Switch to __MARKET__');
        accept.textContent = template.replace('__MARKET__', targetName);
        accept.onclick = () => submit(targetCountry, targetLanguage);
      }
      const keep = dismissButtons.find((button) => !button.classList.contains('dopa-localization-close') && !button.classList.contains('dopa-localization-backdrop'));
      if (keep) keep.textContent = String(config.copy?.keepCurrent || 'Keep current store');
      lastFocused = document.activeElement;
      prompt.hidden = false;
      prompt.setAttribute('aria-hidden', 'false');
      document.body.classList.add('localization-prompt-open');
      window.requestAnimationFrame(() => card?.focus());
    })
    .catch(() => {});
})();

/* DOPA V53 — Snapchat paid-traffic sales engine
   Privacy rule: store and publish only short, sanitized campaign/state/product context.
   Email remains inside Shopify's native customer form submission and never enters analytics payloads. */
(() => {
  const engine = document.querySelector('[data-snap-engine]');
  const configNode = document.getElementById('DopaSnapSalesConfig');
  const acquisitionPage = document.querySelector('[data-snap-acquisition-page]');
  if (!engine || !configNode) return;

  let config = {};
  try { config = JSON.parse(configNode.textContent || '{}'); } catch (_) { return; }
  if (!config.enabled) return;

  const clean = (value, max = 80) => String(value == null ? '' : value)
    .trim()
    .replace(/[^a-zA-Z0-9 _.-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^[-_.]+|[-_.]+$/g, '')
    .slice(0, max);
  const publish = (name, payload = {}) => {
    try { window.DOPAAnalytics?.publish?.(name, payload); } catch (_) {}
  };
  const parseJson = (value, fallback = {}) => { try { return JSON.parse(value || '') || fallback; } catch (_) { return fallback; } };
  const root = window.Shopify?.routes?.root || '/';
  const params = new URLSearchParams(window.location.search);
  const referrerHost = (() => { try { return new URL(document.referrer).hostname.toLowerCase(); } catch (_) { return ''; } })();
  const sourceParam = String(params.get('utm_source') || '').toLowerCase();
  const campaign = {
    utm_source: clean(params.get('utm_source'), 40),
    utm_medium: clean(params.get('utm_medium'), 40),
    utm_campaign: clean(params.get('utm_campaign'), 80),
    utm_content: clean(params.get('utm_content'), 60),
    snap_campaign_id: clean(params.get('snap_campaign_id'), 60)
  };
  const isSnapVisit = Boolean(
    acquisitionPage ||
    campaign.snap_campaign_id ||
    sourceParam.includes('snap') ||
    referrerHost === 'snapchat.com' ||
    referrerHost.endsWith('.snapchat.com')
  );
  let storedCampaign = {};
  try { storedCampaign = parseJson(sessionStorage.getItem('dopa_snap_campaign_v1'), {}); } catch (_) {}
  const currentCampaign = Object.fromEntries(Object.entries(campaign).filter(([, value]) => value));
  if (Object.keys(currentCampaign).length) {
    storedCampaign = { ...storedCampaign, ...currentCampaign, channel: 'snapchat' };
    try { sessionStorage.setItem('dopa_snap_campaign_v1', JSON.stringify(storedCampaign)); } catch (_) {}
  }
  if (isSnapVisit) {
    document.documentElement.dataset.dopaAcquisition = 'snapchat';
    try { sessionStorage.setItem('dopa_snap_visit', '1'); } catch (_) {}
  }
  let rememberedSnap = false;
  try { rememberedSnap = sessionStorage.getItem('dopa_snap_visit') === '1'; } catch (_) {}
  const snapContext = isSnapVisit || rememberedSnap;

  const interestMap = Object.freeze({
    iq300:{ state:'focus', tags:['dopa-interest-iq300','state-focus','format-gum'] },
    kik:{ state:'energy', tags:['dopa-interest-kik','state-energy','format-gum'] },
    calm:{ state:'reset', tags:['dopa-interest-calm','state-reset','format-gum'] },
    luna:{ state:'night', tags:['dopa-interest-luna','state-night','format-gummy'] },
    max:{ state:'fresh', tags:['dopa-interest-max','state-fresh','format-mint'] },
    'focus-shot':{ state:'focus', tags:['dopa-interest-focus-shot','state-focus','format-shot'] },
    'energy-shot':{ state:'energy', tags:['dopa-interest-energy-shot','state-energy','format-shot'] },
    'hydra-shot':{ state:'hydrate', tags:['dopa-interest-hydra-shot','state-hydrate','format-shot'] },
    'reset-shot':{ state:'reset', tags:['dopa-interest-reset-shot','state-reset','format-shot'] },
    shots:{ state:'shots', tags:['dopa-interest-shots','format-shot'] }
  });
  const normalizeInterest = (value) => {
    const key = String(value || '').toLowerCase().trim();
    const aliases = { focus:'iq300', energy:'kik', reset:'calm', night:'luna', fresh:'max', hydrate:'hydra-shot' };
    const resolved = aliases[key] || key;
    return interestMap[resolved] ? resolved : 'iq300';
  };
  const inferInterest = (container) => {
    const direct = container?.dataset?.snapDefaultInterest || acquisitionPage?.dataset?.snapDefaultInterest || engine.dataset.snapDefaultInterest || config.defaultInterest;
    if (direct) return normalizeInterest(direct);
    const path = window.location.pathname.toLowerCase();
    if (path.includes('iq300') || path.includes('focus')) return path.includes('shot') ? 'focus-shot' : 'iq300';
    if (path.includes('kik') || path.includes('energy')) return path.includes('shot') ? 'energy-shot' : 'kik';
    if (path.includes('calm')) return 'calm';
    if (path.includes('reset-shot')) return 'reset-shot';
    if (path.includes('reset')) return 'calm';
    if (path.includes('luna') || path.includes('night')) return 'luna';
    if (path.includes('max') || path.includes('fresh')) return 'max';
    if (path.includes('hydra')) return 'hydra-shot';
    if (path.includes('shots')) return 'shots';
    return 'iq300';
  };
  const campaignTags = () => {
    if (!config.captureCampaignTag) return [];
    const value = { ...storedCampaign, ...currentCampaign };
    return [
      value.snap_campaign_id ? `snap-campaign-${clean(value.snap_campaign_id, 40).toLowerCase()}` : '',
      value.utm_campaign ? `utm-campaign-${clean(value.utm_campaign, 40).toLowerCase()}` : '',
      value.utm_content ? `utm-content-${clean(value.utm_content, 30).toLowerCase()}` : ''
    ].filter(Boolean);
  };
  const channelFor = (container) => clean(container?.dataset?.dopaChannel || (snapContext ? 'snapchat' : 'website'), 24).toLowerCase() || 'website';
  const baseTags = (container) => {
    const source = clean(container?.dataset?.dopaSource || 'snap-landing', 32).toLowerCase() || 'snap-landing';
    const channel = channelFor(container);
    return ['prospect','newsletter','dopa-lead',`dopa-channel-${channel}`,`dopa-surface-${source}`];
  };
  const updateLeadTags = (container, interest) => {
    const resolved = normalizeInterest(interest);
    const field = container.querySelector('[data-snap-lead-tags]');
    if (!field) return resolved;
    const tags = [...baseTags(container), ...interestMap[resolved].tags, ...campaignTags()];
    field.value = [...new Set(tags)].join(',');
    container.dataset.snapSelectedInterest = resolved;
    return resolved;
  };

  const forms = [...document.querySelectorAll('[data-snap-inline-capture]')];
  const startedForms = new WeakSet();
  forms.forEach((container) => {
    const form = container.querySelector('.dopa-snap-lead-form');
    const select = container.querySelector('[data-snap-interest-select]');
    const email = form?.querySelector('input[name="contact[email]"]');
    if (!form || !select) return;
    const initial = inferInterest(container);
    if ([...select.options].some((option) => option.value === initial)) select.value = initial;
    updateLeadTags(container, select.value);
    select.addEventListener('change', () => {
      const interest = updateLeadTags(container, select.value);
      publish('snap_interest_selected', { interest, state: interestMap[interest].state, surface: clean(container.dataset.dopaSource, 32), channel: channelFor(container) });
    });
    email?.addEventListener('focus', () => {
      if (startedForms.has(form)) return;
      startedForms.add(form);
      const interest = updateLeadTags(container, select.value);
      publish('snap_lead_started', { interest, state: interestMap[interest].state, surface: clean(container.dataset.dopaSource, 32), channel: channelFor(container) });
    });
    form.addEventListener('submit', () => {
      const interest = updateLeadTags(container, select.value);
      publish('snap_lead_submit_attempted', { interest, state: interestMap[interest].state, surface: clean(container.dataset.dopaSource, 32), channel: channelFor(container) });
    });
    if (container.querySelector('[data-snap-lead-success]')) {
      const interest = updateLeadTags(container, select.value);
      try { localStorage.setItem('dopa_snap_lead_until', String(Date.now() + 30 * 86400000)); } catch (_) {}
      publish('snap_lead_confirmed', { interest, state: interestMap[interest].state, surface: clean(container.dataset.dopaSource, 32), channel: channelFor(container) });
    }
  });

  if (acquisitionPage) {
    publish('snap_landing_viewed', {
      interest: inferInterest(acquisitionPage),
      surface: 'snap-acquisition',
      campaign: clean(storedCampaign.utm_campaign || currentCampaign.utm_campaign, 80)
    });
  }
  document.addEventListener('click', (event) => {
    const primary = event.target.closest?.('[data-snap-primary-action], [data-snap-primary-cta]');
    if (primary) publish('snap_primary_clicked', { destination_path: (() => { try { return new URL(primary.href, location.origin).pathname; } catch (_) { return ''; } })(), surface: primary.closest('[data-snap-acquisition-page]') ? 'landing' : 'dock' });
    const interestLink = event.target.closest?.('[data-snap-interest-link]');
    if (interestLink) {
      const interest = normalizeInterest(interestLink.dataset.snapInterestLink);
      publish('snap_interest_selected', { interest, state: interestMap[interest].state, surface:'state-router' });
    }
    const formatSwitch = event.target.closest?.('[data-snap-format-switch]');
    if (formatSwitch) publish('snap_format_switch_clicked', { state: clean(formatSwitch.closest('[data-dopa-format-switch]')?.dataset.dopaState, 24), destination_path: (() => { try { return new URL(formatSwitch.href, location.origin).pathname; } catch (_) { return ''; } })() });
  }, true);

  const dock = engine.querySelector('[data-snap-dock]');
  const nudge = engine.querySelector('[data-snap-nudge]');
  const sheet = engine.querySelector('[data-snap-lead-sheet]');
  const sheetCard = sheet?.querySelector('.dopa-snap-sheet-card');
  const dockShop = engine.querySelector('[data-snap-primary-cta]');
  const focusables = (rootNode) => [...rootNode.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((el) => !el.hidden && el.offsetParent !== null);
  let lastFocused = null;
  const primaryUrl = acquisitionPage?.dataset.snapPrimaryUrl || config.primaryUrl || dockShop?.getAttribute('href') || '/collections/all';
  if (dockShop && primaryUrl) dockShop.setAttribute('href', primaryUrl);
  const openSheet = (trigger) => {
    if (!sheet) return;
    lastFocused = trigger || document.activeElement;
    const defaultInterest = inferInterest(trigger?.closest?.('[data-snap-default-interest]') || acquisitionPage || engine);
    sheet.querySelectorAll('[data-snap-inline-capture]').forEach((container) => {
      const select = container.querySelector('[data-snap-interest-select]');
      if (select && [...select.options].some((option) => option.value === defaultInterest)) select.value = defaultInterest;
      updateLeadTags(container, select?.value || defaultInterest);
    });
    sheet.hidden = false;
    sheet.setAttribute('aria-hidden','false');
    document.body.classList.add('dopa-snap-sheet-open');
    window.requestAnimationFrame(() => (sheet.querySelector('[data-snap-lead-success]') || sheet.querySelector('input[type="email"]') || sheetCard)?.focus());
    publish('snap_lead_sheet_opened', { interest:defaultInterest, surface: trigger?.closest?.('[data-snap-acquisition-page]') ? 'landing' : 'global' });
  };
  const closeSheet = () => {
    if (!sheet) return;
    sheet.hidden = true;
    sheet.setAttribute('aria-hidden','true');
    document.body.classList.remove('dopa-snap-sheet-open');
    lastFocused?.focus?.();
  };
  document.querySelectorAll('[data-snap-open-lead]').forEach((button) => button.addEventListener('click', (event) => { if (sheet) event.preventDefault(); openSheet(button); }));
  sheet?.querySelectorAll('[data-snap-close-lead]').forEach((button) => button.addEventListener('click', closeSheet));
  sheet?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') return closeSheet();
    if (event.key !== 'Tab') return;
    const items = focusables(sheet);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  if (sheet?.querySelector('[data-snap-lead-success]')) openSheet(engine);

  if (snapContext || acquisitionPage) {
    const hasNativeMobileBuy = Boolean(document.querySelector('[data-mobile-buy]'));
    if (dock && config.dock && !hasNativeMobileBuy) dock.hidden = false;
    if (nudge && config.nudge) {
      let dismissed = 0;
      let leadCapturedUntil = 0;
      let shownThisSession = false;
      try {
        dismissed = Number(localStorage.getItem('dopa_snap_nudge_until') || 0);
        leadCapturedUntil = Number(localStorage.getItem('dopa_snap_lead_until') || 0);
        shownThisSession = sessionStorage.getItem('dopa_snap_nudge_shown') === '1';
      } catch (_) {}
      if (dismissed < Date.now() && leadCapturedUntil < Date.now() && !shownThisSession) {
        const delay = Math.max(5, Math.min(30, Number(config.nudgeDelay) || 10)) * 1000;
        window.setTimeout(() => {
          if (!document.body.classList.contains('cart-open') && !document.body.classList.contains('dopa-snap-sheet-open')) {
            nudge.hidden = false;
            try { sessionStorage.setItem('dopa_snap_nudge_shown', '1'); } catch (_) {}
          }
        }, delay);
      }
      nudge.addEventListener('click', () => {
        nudge.hidden = true;
        try { localStorage.setItem('dopa_snap_nudge_until', String(Date.now() + 3 * 86400000)); } catch (_) {}
      });
    }
  }
  document.addEventListener('dopa:cart-added', () => {
    if (nudge) nudge.hidden = true;
    if (dock) dock.classList.add('is-after-add');
    closeSheet();
  });

  document.querySelectorAll('[data-snap-copy-code]').forEach((button) => button.addEventListener('click', async () => {
    const code = button.closest('.dopa-snap-code')?.querySelector('[data-snap-offer-code]')?.textContent?.trim();
    if (!code) return;
    try { await navigator.clipboard.writeText(code); button.textContent = config.copy?.copied || 'Copied'; } catch (_) {}
  }));

  const money = (cents, currency) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:currency || 'INR', maximumFractionDigits:2 }).format((Number(cents) || 0) / 100); }
    catch (_) { return `${currency || ''} ${((Number(cents) || 0) / 100).toFixed(2)}`.trim(); }
  };
  document.querySelectorAll('[data-snap-stack-builder]').forEach((builder) => {
    if (builder.dataset.snapStackBound === 'true') return;
    builder.dataset.snapStackBound = 'true';
    const inputs = [...builder.querySelectorAll('[data-snap-stack-input]:not([disabled])')];
    const countNode = builder.querySelector('[data-snap-stack-count]');
    const totalNode = builder.querySelector('[data-snap-stack-total]');
    const button = builder.querySelector('[data-snap-stack-add]');
    const status = builder.querySelector('[data-snap-stack-status]');
    const currency = builder.dataset.stackCurrency || window.Shopify?.currency?.active || 'INR';
    const selected = () => inputs.filter((input) => input.checked && input.dataset.variantId);
    const render = () => {
      const items = selected();
      const total = items.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
      const template = items.length === 1 ? (config.copy?.selectedOne || '__COUNT__ selected') : (config.copy?.selectedOther || '__COUNT__ selected');
      if (countNode) countNode.textContent = template.replace('__COUNT__', String(items.length));
      if (totalNode) totalNode.textContent = money(total, currency);
      if (button) {
        button.disabled = items.length < 2;
        button.textContent = items.length < 2 ? (config.copy?.selectShots || 'Select 2+ shots') : String(config.copy?.addStack || 'Add stack · __TOTAL__').replace('__TOTAL__', money(total, currency));
      }
    };
    inputs.forEach((input) => input.addEventListener('change', render));
    button?.addEventListener('click', async () => {
      const chosen = selected();
      if (chosen.length < 2) { if (status) status.textContent = config.copy?.selectTwo || 'Select at least two shots.'; return; }
      button.disabled = true;
      if (status) status.textContent = config.copy?.addingStack || 'Adding your shot stack…';
      const items = chosen.map((input) => ({
        id: Number(input.dataset.variantId),
        quantity: 1,
        ...(input.dataset.preorder === 'true' ? { properties:{ 'Pre-order delivery':'Estimated 1–4 weeks' } } : {})
      }));
      try {
        const response = await fetch(`${root}cart/add.js`, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify({ items }) });
        if (!response.ok) throw new Error('cart add failed');
        const cartResponse = await fetch(`${root}cart.js`, { headers:{ 'Accept':'application/json' }, credentials:'same-origin' });
        if (!cartResponse.ok) throw new Error('cart read failed');
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('dopa:cart-updated', { detail:{ cart, source:'snap-shot-stack' } }));
        document.dispatchEvent(new CustomEvent('dopa:cart-added', { detail:{ cart, source:'snap-shot-stack' } }));
        publish('snap_shot_stack_added', { selected_count:chosen.length, states:chosen.map((input) => clean(input.dataset.stackState, 20)).join('|'), subtotal_cents:chosen.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0), currency });
        chosen.forEach((input) => { input.checked = false; });
        if (status) status.textContent = config.copy?.stackAdded || 'Shot stack added to your bag.';
      } catch (_) {
        if (status) status.textContent = config.copy?.stackError || 'We could not add the stack. Please try again.';
      } finally { render(); }
    });
    render();
  });
})();

